import { Snackbar, Alert, Button } from "@mui/material";
import { useState } from "react";
import ReactDOM from "react-dom"; // Import for React Portal

const ErrorFallback = () => {
  const [open, setOpen] = useState(true);

  const snackbar = (
    <Snackbar
      open={open}
      autoHideDuration={null} // Ensures it stays until manually closed
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      sx={{ zIndex: 9999 }} // Ensures it's on top
    >
      <Alert
        onClose={() => setOpen(false)}
        severity="error"
        variant="filled"
        action={
          <Button
            color="inherit"
            size="small"
            onClick={() => window.location.reload()}
          >
            REFRESH
          </Button>
        }
      >
        <strong>Oops! Something went wrong.</strong>
        <br />
        Please refresh the page or contact IT admin.
      </Alert>
    </Snackbar>
  );

  // Use React Portals to keep Snackbar outside normal DOM flow
  return ReactDOM.createPortal(snackbar, document.body);
};

export default ErrorFallback;
